import useBreakpoints from "@hooks/useBreakPoinst";
import {
  CardContainer,
  PriceSection,
  PackageName,
  PriceContainer,
  OriginalPrice,
  BillingInfo,
  Divider,
  SubscribeButton,
  ButtonText,
  StyledLeftArrow,
  FeaturesList,
  FeatureItem,
  StyledCheckFeat,
  StyledArrowRight,
  StyledRightArrow,
} from "../styles";
import { useRTL } from "@hooks/useIsRTL";
import { useTranslation } from "react-i18next";

interface ICardProps {
  packageName?: string;
  packageWithsFeature?: string[];
  priceForEachProperty?: string;
  priceForEachPropertyBeforeDiscount?: string;
  onPress?: () => void;
  handleDetails?: () => void;
}
const Card = ({
  packageName,
  packageWithsFeature,
  priceForEachProperty,
  priceForEachPropertyBeforeDiscount,
  onPress,
  handleDetails,
}: ICardProps) => {
  const { isPhone } = useBreakpoints();
  const { isRTL } = useRTL();
  const { t } = useTranslation();

  return (
    <CardContainer $isPhone={isPhone}>
      {/* Price section */}
      <PriceSection onClick={handleDetails} $isPhone={isPhone}>
        <PackageName>{packageName}</PackageName>
        <PriceContainer>
          {priceForEachProperty} {t("chooseSubscription.currency")}
          <OriginalPrice>{priceForEachPropertyBeforeDiscount} </OriginalPrice>
        </PriceContainer>
        <BillingInfo>{t("chooseSubscription.billingInfo")}</BillingInfo>
      </PriceSection>

      <Divider />

      {/* Subscribe Now section */}
      <SubscribeButton onClick={onPress}>
        <ButtonText>{t("chooseSubscription.subscribeNow")}</ButtonText>
        {isRTL ? <StyledLeftArrow /> : <StyledRightArrow />}
      </SubscribeButton>

      <Divider />

      {/* List of features section */}
      <FeaturesList>
        {packageWithsFeature?.map((item, index) => (
          <FeatureItem key={index}>
            <StyledCheckFeat /> {item}
          </FeatureItem>
        ))}
      </FeaturesList>
    </CardContainer>
  );
};

export default Card;
